import instance from "@/utils/request";

function postRequest(url, data) {
  return new Promise(function (resolve, reject) {
    instance({
      url: url,
      method: "post",
      data,
    }).then(
      (res) => {
        resolve(res.data);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

function getRequest(url) {
  return new Promise(function (resolve, reject) {
    instance({
      url: url,
      method: "get",
    }).then(
      (res) => {
        resolve(res.data);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

export function getSlideshow({ t = {}, p = {} } = {}) {
  return postRequest("/website/slideShow/list", {
    t,
    p,
  });
}

export function getBusiness() {
  return getRequest("/website/businessMovement/queryWebsite");
}

export function getCaseMaintenance({ t = {}, p = {} } = {}) {
  return postRequest("/website/caseMaintenance/list", {
    t,
    p,
  });
}

export function getContact({ t = {}, p = {} } = {}) {
  return postRequest("/website/contact/list", {
    t,
    p,
  });
}

export function addOnline(data) {
  return postRequest("/website/onlineMessage/add", data);
}
